







import {Vue, Component} from 'vue-property-decorator';
import { stringify } from 'qs';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
  }
})
export default class PaycoConfigIframe extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + `/configuration/payment/payco-config?${stringify({
      ...this.$route.query,
      serviceType: 'PREMIUM',
    })}`;
  }

  created() {
    this.setRemoteSrc();
  }
}
